import React from 'react'
import PropTypes from 'prop-types'
import store from 'state/store'
import { Stack } from '@mui/material_modern'
import * as Sentry from '@sentry/react'
import AlertSnackbar from 'components/generic/snackbars'
import { hideFormModal } from 'state/ui/index'
import { isProduction } from 'utils/envs'

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { alertOpen: false, errorMessage: '' }
    this.handleClose = this.handleClose.bind(this)
  }

  static getDerivedStateFromError(error) {
    const componentWithError = (error.stack.split('\n')[1] || '').trim().split(' ')[1]

    let errorMessage = `${error.name}: ${error.message}`

    if (window.Meticulous?.isRunningAsTest) {
      // Display a generic error message during meticulous tests
      // the bundled .js object names and line numbers always change so we don't show them for the purpose of screenshot comparison
      errorMessage = 'An error occurred during test execution.'
    } else if (!isProduction) {
      // In development, show more details
      errorMessage += ` in ${componentWithError}`
    }

    return {
      alertOpen: true,
      errorMessage,
    }
  }

  componentDidCatch(error) {
    store.dispatch(hideFormModal()) // close form modal in case error is originating from a form modal
    Sentry.captureException(error)
  }

  handleClose() {
    this.setState({ alertOpen: false })
  }

  render() {
    const { children } = this.props
    const { alertOpen, errorMessage } = this.state
    if (alertOpen && !isProduction) {
      return <Stack sx={{ color: 'white', p: 2 }}>{errorMessage}</Stack>
    }
    return (
      <>
        <AlertSnackbar message={errorMessage} isOpen={alertOpen} severity="error" handleClose={this.handleClose} />
        {children}
      </>
    )
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
}

export default ErrorBoundary
